import { ApplicationConfig, FactoryProvider, inject } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';

import { TOAST_MESSAGES_SERVICE } from '@hdms/shared/common-types';
import {
  OAUTH_LOGIN_SYNC_PROVIDER,
  PUNCHOUT_SESSION_COOKIE_NAME,
  SERVICE_WORKER_PROVIDER,
  TOKEN_STORE_PROVIDER
} from '@hdms/shared/data-access';
import { HOME_LINK_ENABLED, ToastMessagesService } from '@hdms/shared/ui-core';
import { CookieService, DATEPICKER_FORMAT_PROVIDERS, PlatformService, TAB_SYNC_CHANNEL } from '@hdms/shared/util-core';

import { HDMS_APP_ID } from './constants';

const HOME_LINK_PROVIDER: FactoryProvider = {
  provide: HOME_LINK_ENABLED,
  useFactory: () =>
    inject(PlatformService).isServer || inject(CookieService).get<boolean>(PUNCHOUT_SESSION_COOKIE_NAME) !== true
};

/**
 * Providers used in browser environment only
 */
export const APP_BROWSER_CONFIG: ApplicationConfig = {
  providers: [
    provideAnimations(),
    {
      provide: TAB_SYNC_CHANNEL,
      useValue: HDMS_APP_ID
    },
    {
      provide: TOAST_MESSAGES_SERVICE,
      useExisting: ToastMessagesService
    },
    SERVICE_WORKER_PROVIDER,
    TOKEN_STORE_PROVIDER,
    DATEPICKER_FORMAT_PROVIDERS,
    OAUTH_LOGIN_SYNC_PROVIDER,
    HOME_LINK_PROVIDER
  ]
};
